import React from 'react';
import PropTypes from 'prop-types';

const IconShipmentDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={props.style}
    height={props.size}
    width={props.size}
    viewBox="0 0 26 26"
  >
    <g
      fill="#fff"
      fillRule="evenodd"
      stroke={props.color}
      transform="translate(1 1)"
    >
      <g strokeLinejoin="round">
        <path
          d="m12 24v-16.36363636l-12-3.27272728v14.18181814z"
          fill="#fff"
          strokeWidth="1"
        />
        <path
          d="m0 4.36363636 12-4.36363636 12 3.27272727-12 4.36363637z"
          fill="#fff"
          strokeWidth="1"
        />
        <path
          d="m12 7.63636364v16.36363636l12-5.4545455v-15.27272723z"
          fill="#fff"
          strokeWidth="1"
        />
      </g>
    </g>
    <text
      style={{
        fontFamily: 'Roboto, sans-serif',
        fill: props.color,
        fontSize: '13px',
      }}
      transform="translate(3.5 19)"
    >
      $
    </text>
  </svg>
);

IconShipmentDollar.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};

IconShipmentDollar.defaultProps = {
  color: '#00aa8d',
  size: 26,
  style: {},
};

export default IconShipmentDollar;
